import React from 'react'
import {_GPY,__GPYPost} from '../env.js'
import SHA256 from 'sha.js/sha256';
import GpyKeybindingButton from './gametypes/lib/GpyKeybindingButton.js';

class OBS extends React.Component {

  constructor (props) {
	    super(props)
      this.state = {
        showOBSPanel: _GPY.uiStates.showOBSPanel!==undefined?_GPY.uiStates.showOBSPanel:false,
        scenes:[],
        currentScene:"none",
        connection:{},
        currentHost: "localhost",
        currentPort: "4444",
        currentPass: "",
        rec: false,
        stream: false,
        auth:false,
        _fail:false,
        stateName: "OBS",
		  }
	}

  toggleOBSPanel(){
       var nv = !this.state.showOBSPanel;
       this.setState({showOBSPanel:nv},()=>{
         if(this.props.scoreboard !== undefined){
            this.props.scoreboard.forceUpdate();
         };
          __GPYPost('setUIState',{showOBSPanel:nv});
       });
  }

  switchToScene(name) {
    console.log("OBS switchToScene",name);
    if(this.state.connection.readyState === WebSocket.OPEN && this.state.auth) {
        this.state.connection.send(JSON.stringify({"request-type":"SetCurrentScene",'message-id':'22','scene-name':name}));
    }
  }

  componentDidMount() {
    if(this.props.scoreboard !== undefined && this.props.scoreboard.registerComponent !== undefined){
     this.props.scoreboard.registerComponent(this.state.stateName,this);
   };
  }

  componentWillUnmount() {
    this.disconnect();
  }

  connect(){
     var c = this.createConnection();
     this.setState({connection : c,_fail:false});
  }

   reconnect() {
       clearInterval(this.interval);
       this.interval = undefined;

       var c = this.createConnection();
       this.setState({connection : c,_fail:false});
  }

   createConnection() {

      var connection = new WebSocket("ws://"+this.state.currentHost+":"+this.state.currentPort);
      connection.onopen =  () => {
            console.log('OBS WebSocket: connected');

            var args = {};
            args['request-type'] = "GetAuthRequired";
            args['message-id'] = "10";
            var msg = JSON.stringify(args)
            console.log("sendMessage:",msg);
            connection.send(msg);

      };

      connection.onerror = (error) => {
            console.log("onerror",error);
            if(this.interval === undefined) {
              this.interval = setInterval(() => this.reconnect(), (2 * 1000));
            }
      };

      connection.onclose = (error) => {
            console.log("onclose",error);
      };

      connection.onmessage =  (e) => {
          var data =JSON.parse(e.data);
          console.log("onmessage",e);
          console.log("onmessage",data);

          console.log("messageId",data['message-id']);

          if(data['scene-name']!==undefined) {
            this.setState({currentScene:data['scene-name']});
          }
          if(data['update-type']!==undefined) {
            if(data['update-type']==="RecordingStarted") {
              this.setState({rec:true});
              this.sendStateEvent("RecordingStarted");
            }
            if(data['update-type']==="RecordingStopping") {
              this.setState({rec:false});
              this.sendStateEvent("RecordingStopping");
            }
            if(data['update-type']==="StreamStarting") {
              this.setState({stream:true});
              this.sendStateEvent("StreamStarting");
            }
            if(data['update-type']==="StreamStopped") {
              this.setState({stream:false});
              this.sendStateEvent("StreamStopped");
            }
          }

          if(data['message-id']==="11"){
            if(data['status'] === "ok") {
              this.setState({auth:true,_fail:false},()=>{
                this.getSceneList();
              });
            } else {
              this.setState({auth:false,_fail:true});
            }
          }if(data['message-id']==="10") {
              if(data['authRequired']) {
                var args = {};
                args['request-type'] = "Authenticate";
                args['message-id'] = "11";
                args['auth'] = this.hash(data['salt'], data['challenge'], this.state.currentPass);
                var msg = JSON.stringify(args)
                console.log("sendMessage:",msg);
                connection.send(msg);
              } else  {
                this.setState({auth:true},()=>{
                  this.getSceneList();
                });
              }
          } if(data['message-id']==="21") {
            this.setState({scenes:data.scenes,currentScene:data['current-scene']});
            this.setState({scenes:data.scenes});
          } else if (data['message-id']==="22") {

          } else if (data['message-id']==="30") {

          } else if (data['message-id']==="31") {

          } else if (data['message-id']==="32") {

          } else if (data['message-id']==="33") {

          }

      }
      return connection;
  }

  sendStateEvent(name){
    var obj = {status:name,gpyComponentID:"OBS"};
    obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
    obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
    __GPYPost('setGameState', {OBSRecording:JSON.stringify(obj)});
  }
  hash(salt = '', challenge = '', msg){
      const hash = new SHA256().update(msg).update(salt).digest('base64');
      const resp = new SHA256().update(hash).update(challenge).digest('base64');
      return resp;
  }

  disconnect() {
    if(this.state.connection!==undefined && this.state.connection.readyState === WebSocket.OPEN) {
      this.state.connection.close();
       this.setState({connection : {},currentScene:"none"});
    }
  }

  getSceneList() {
    if(this.state.connection.readyState === WebSocket.OPEN){
      var args = {};
      args['request-type'] = "GetSceneList";
      args['message-id'] = "21";
      var msg = JSON.stringify(args)
      console.log("sendMessage:",msg);
      this.state.connection.send(msg);
    } else {
      this.setState({scenes:[]});
    }
  }


  startStreaming(){
    this.state.connection.send(JSON.stringify({"request-type":"StartStreaming",'message-id':'30'}));
  }
  stopStreaming(){
    this.state.connection.send(JSON.stringify({"request-type":"StopStreaming",'message-id':'31'}));
  }
  startRecording () {
    this.state.connection.send(JSON.stringify({"request-type":"StartRecording",'message-id':'32'}));
  }
  stopRecording(){
    this.state.connection.send(JSON.stringify({"request-type":"StopRecording",'message-id':'33'}));
  }


	render () {
     if(!this.state.showOBSPanel) {
       return ("");
     }
     if(this.state.connection.readyState === WebSocket.OPEN && this.state.auth){
       return (
         <div className='row'>
          <div className="col-12">
            <button onClick={()=>{this.disconnect()}} className="btn btn-light">Disconnect</button>
             |
              {this.state.scenes!==undefined?this.state.scenes.map((s)=>{
                 if(this.state.currentScene===s.name) {
                    return (<GpyKeybindingButton stateName={"OBS_"+s.name} scoreboard={this.props.scoreboard} key={s.name} onClick={()=>{this.state.connection.send(JSON.stringify({"request-type":"SetCurrentScene",'message-id':'22','scene-name':s.name}))}} className="btn btn-success" title={s.name}/>);
                 } else {
                    return (<GpyKeybindingButton stateName={"OBS_"+s.name} scoreboard={this.props.scoreboard} key={s.name} onClick={()=>{this.state.connection.send(JSON.stringify({"request-type":"SetCurrentScene",'message-id':'22','scene-name':s.name}))}} className="btn btn-light" title={s.name}/>);
                 }
              }):""}
              |

              {this.state.stream?
              <div className="btn-group" role="group" aria-label="Basic example">
                  <button  className="btn btn-warning disabled"><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
                  <button  onClick={()=>{this.stopStreaming()}} className="btn btn-warning"><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
              </div>
              :
              <div className="btn-group" role="group" aria-label="Basic example">
                  <button  onClick={()=>{this.startStreaming()}} className="btn btn-warning"><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
                  <button className="btn btn-warning disabled"><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
              </div>
              }

              {this.state.rec?
              <div className="btn-group" role="group" aria-label="Basic example">
                <button className="btn btn-danger disabled"><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
                <button  onClick={()=>{this.stopRecording()}} className="btn btn-danger"><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
              </div>
              :
              <div className="btn-group" role="group" aria-label="Basic example">
                <button  onClick={()=>{this.startRecording()}} className="btn btn-danger"><span class="glyphicon glyphicon-play" aria-hidden="true"></span></button>
                <button  className="btn btn-danger disabled"><span class="glyphicon glyphicon-stop" aria-hidden="true"></span></button>
              </div>
              }
          </div>
          </div>
       );
     } else {
       return (
         <div className='row'>
             <div className="col">
                 <button onClick={()=>{this.connect()}} className="btn btn-light">Connect</button>
                 <a className="pl-2" href="https://www.guppyi.com/obs-connect/" target="_new">instructions</a>
            </div>
            <div className="col-6 p-0">
                <div class="input-group mb-3">
                  <input type="text" value={this.state.currentHost} onChange={(e)=>{this.setState({currentHost:e.target.value})}} placeholder="host" className="form-control"/>
                  <input type="text" value={this.state.currentPort} onChange={(e)=>{this.setState({currentPort:e.target.value})}} placeholder="port" className="form-control"/>
                </div>
            </div>
            <div className="col-3 p-0 pl-1"><input type="password" value={this.state.currentPass} onChange={(e)=>{this.setState({currentPass:e.target.value})}} placeholder="password or empty" className="form-control"/></div>

            {this.state._fail? <div className="col-12 p-0"><div className="alert alert-danger" role="alert">OBS Login Fail</div></div>:""}
        </div>
       );
     }
	 }
}
export default OBS
